export default __webpack_public_path__ + "static/media/social_apple.a043f19d.svg";